import template from './bf-sales-channel-property-mapping-grid.html.twig';

const {Component} = Shopware;

Component.extend('bf-sales-channel-property-mapping-grid', 'sw-data-grid', {
    template
});
